import React, { useEffect } from "react";
import { Box, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import BlockIcon from "@mui/icons-material/Block";
import { useAuth } from "../../context/authContext";

const Forbidden = () => {
  const { isAuthenticated, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && !isAuthenticated) {
      navigate("/");
    }
  }, [isAuthenticated, loading, navigate]);

  if (loading || !isAuthenticated) return null;

  return (
    <>
      <Box
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        height="100vh"
        textAlign="center"
        width="100%"
        sx={{ bgcolor: "#f9f9f9", p: 4 }}
      >
        <BlockIcon color="error" sx={{ fontSize: 60, mb: 2 }} />
        <Typography variant="h3" color="error" gutterBottom>
          403 - Accès refusé
        </Typography>
        <Typography variant="body1" color="text.secondary" mb={4}>
          Vous n’avez pas les autorisations nécessaires pour accéder à cette page.
        </Typography>
      </Box>
    </>
  );
};

export default Forbidden;
